// contexts/SubGrupoContext.js
import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { fetchData, postData, putData, deleteData } from '../../services/Api';
import { useAlert } from '../geral/AlertContext';
import { useMessage } from '../geral/MessageContext';

const SubGrupoContext = createContext();

export const useSubGrupo = () => useContext(SubGrupoContext);

export const SubGrupoProvider = ({ children }) => {
    const [subGrupos, setSubGrupos] = useState([]);
    const { showAlert } = useAlert();
    const { showMessage } = useMessage();

    const fetchSubGrupos = useCallback(async () => {
        try {
            const result = await fetchData('/SubGrupo');
            setSubGrupos(result);            
        } catch (error) {
            console.error("Erro ao buscar subgrupos:", error);
            showMessage(`Erro ao buscar subgrupos! ${error?.message || error}`, 'danger');
        }
    }, [showMessage]);

    useEffect(() => {
        fetchSubGrupos();
    }, [fetchSubGrupos]);

    const addSubGrupo = async (subGrupo) => {
        try {
            const result = await postData('/SubGrupo', subGrupo);
            setSubGrupos([...subGrupos, result]);
            showAlert('SubGrupo adicionado com sucesso!');
        } catch (error) {
            console.error("Erro ao adicionar subgrupo:", error);
            showMessage('Erro ao adicionar subgrupo!\n' + error, 'danger');
        }
    };

    const updateSubGrupo = async (subGrupo) => {
        try {
            const result = await putData('/SubGrupo', subGrupo);
            setSubGrupos((subGrupos) =>
                subGrupos.map((sg) => (sg.id === result.id ? result : sg))
            );
            showAlert('SubGrupo alterado com sucesso!');
        } catch (error) {
            console.error("Erro ao atualizar subgrupo:", error);
            showAlert('Erro ao alterar subgrupo!', 'danger');
        }
    };

    const deleteSubGrupo = async (id) => {
        try {
            await deleteData('/SubGrupo', { subGrupoId: id });
            setSubGrupos(subGrupos.filter(sg => sg.id !== id));
            showAlert('SubGrupo excluído com sucesso!');
        } catch (error) {
            console.error("Erro ao excluir subgrupo:", error);
            showAlert('Erro ao excluir subgrupo!', 'danger');
        }
    };

    return (
        <SubGrupoContext.Provider value={{ subGrupos, addSubGrupo, updateSubGrupo, deleteSubGrupo }}>
            {children}
        </SubGrupoContext.Provider>
    );
};